import { Button, Card, Modal, Typography } from "@mui/material";
import React from "react";
import { icons } from "../../assets/icons/icons";
import { colors } from "../../values/colors";

const WarningModal = ({ open, onClose, onConfirm, title }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Card
        sx={{
          width: 400,
          px: 3,
          py: 6,
          borderRadius: "16px",
          boxShadow: "0px 4px 25px rgba(0,0,0,0.15)",
          textAlign: "center",
        }}
      >
        <img src={icons.warn} alt="warn" />
        <Typography sx={{ fontSize: "1.5rem", fontWeight: "600", my: "1rem" }}>
          {title}
        </Typography>
        <Button
          variant="contained"
          onClick={onConfirm}
          sx={{
            background: colors.linearGradent,
            color: "#fff",
            textTransform: "none",
            borderRadius: "999px",
            width: "9rem",
            paddingY: ".5rem",
          }}
        >
          Continue
        </Button>
      </Card>
    </Modal>
  );
};

export default WarningModal;
